import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {
  zadPromotionByIdUrl,
  zadPromotionStatusUrl,
  zadPromotionUpdateUrl,
  zadPromotionsUrl,
} from '../../api'
import {buildZadListQuery} from '../zad/query'
import {parseZadApiError} from '../zad/errors'
import {extractPromotionItem, extractPromotionList} from '../zad/promotionHelpers'
import {
  CreateZadPromotionRequest,
  FetchZadPromotionByIdRequest,
  FetchZadPromotionsRequest,
  UpdateZadPromotionRequest,
  UpdateZadPromotionStatusRequest,
} from './types'

function promotionResult(data: unknown) {
  return {
    success: true as const,
    item: extractPromotionItem(data),
  }
}

export const fetchZadPromotions = createAsyncThunk(
  'zadPromotions/fetch',
  async (payload: FetchZadPromotionsRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(
        `${zadPromotionsUrl}?${buildZadListQuery({
          pageNumber: payload.pageNumber,
          pageCount: payload.pageCount,
        })}`
      )
      const list = extractPromotionList(res.data || {})
      return {
        success: true as const,
        items: list.items,
        total: list.total,
        totalPages: list.totalPages,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadPromotionById = createAsyncThunk(
  'zadPromotions/fetchById',
  async (payload: FetchZadPromotionByIdRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadPromotionByIdUrl(payload.id))
      return promotionResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const createZadPromotion = createAsyncThunk(
  'zadPromotions/create',
  async (payload: CreateZadPromotionRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromotionsUrl, payload.body)
      return promotionResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadPromotion = createAsyncThunk(
  'zadPromotions/update',
  async (payload: UpdateZadPromotionRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromotionUpdateUrl(payload.id), payload.body)
      return promotionResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadPromotionStatus = createAsyncThunk(
  'zadPromotions/updateStatus',
  async (payload: UpdateZadPromotionStatusRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadPromotionStatusUrl(payload.id), {
        isActive: payload.isActive,
      })
      return promotionResult(res.data)
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
